<template lang="pug">
  v-row(align="center" no-gutters).mt-3.container-card
    v-col(cols=12)
      div(
        style="overflow-x: auto; overflow-y: hidden; white-space: nowrap; width:100%;"
      ) 
        n-btn-round(
          v-for="(tab,iT) in tabs" 
          :key="iT"
          :color="tab.tab === currentTab ? 'var(--btn-activate-index-v2)' : ''"
          :style="tab.tab === currentTab ? 'border:2px' : '' "
          :block="false"
          @click="currentTab = tab.tab"
        ).mt-2.mx-1.px-2
          v-img(v-if="tab.icon" :src="tab.icon" :max-width="isMobile ? 12 : 24").mr-1 
          b {{ $t(tab.name) }}
    
    v-col(v-if="subTabs" cols=12)
      div(
        style="overflow-x: auto; overflow-y: hidden; white-space: nowrap; width:100%;"
      )
        n-btn-round(
          v-for="(tab, iT) in subTabs" 
          :key="iT"
          :color="tab.id === currentSubtab ? 'var(--bg-sub-card-active)' : 'var(--bg-sub-card-no-active)'"
          :style="tab.id === currentSubtab ? 'border:2px' : '' "
          :block="false"
          @click="currentSubtab = tab.id"
        ).mt-3.mx-1.px-2.sub-category
          | {{ $t(tab.name) }}
    
    v-col(cols=12)
      v-row(no-gutters).mt-4
        v-col.pa-2(
          v-for='(item, i) in items'
          :key='i'
          cols=3
          sm=3
          md=2
          lg=1
        ) 
          v-card(
            class="toolbartab"
            :style="{'border-radius':'25px','color':'var(--bg-main-color-v2)'}"
            height="100%"
            :disabled='item.is_closed'
            @click='gotoExternalGame(item.id,item.name,item.category_game_type_id)'
          )
            v-img(
              cover
              center
              height="100%"
              aspect-ratio="1"
              :src=' item.is_external ? item.image_url : externalGamePath(item.id)' 
            )
          

</template>
<script>
import { service as apiExternal } from '@/apis'       
import { IsInternalApp } from '@/plugins/checkType'
import { externalGamePath } from '@/plugins/mapImage'
import { ROUTE_INTERNAL_LOTTO, ROUTE_POWER_BALL } from '@/const/route'
import { isGameTypeIdSeamless } from '@/const/gameId'
const ALL = 0
const LOTTO = 1
const CASINO = 2
const SPORT = 3
const SLOT = 4
const POWER_BALL = 5
const EXTERNALTAB = [
  { tab: CASINO,name: 'casino',icon:require('@/assets/nav/submenu/icon_submenu2.svg') },
  { tab: SPORT,name: 'sport',icon:require('@/assets/nav/submenu/icon_submenu16.svg') },
  { tab: SLOT,name: 'slot',icon:require('@/assets/nav/submenu/icon_submenu15.svg') },
  { tab: POWER_BALL,name: 'powerball',icon:require('@/assets/nav/submenu/icon_power_ball.svg') },
]
const INTERNALTAB = [
  { tab: ALL,name: 'all',icon:null },
  { tab: LOTTO,name: 'lotto',icon:require('@/assets/nav/submenu/icon_lotto.svg') },
]

export default {
  data: () => ({
    currentTab : ALL,
    currentSubtab: ALL,
    tabs: [],
  }),
  computed: { 
    externalGame () {
      return this.$store.getters['externalGame/GETTERS_EXTERNALGAME']
    }, 
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    },

    items () {
      const internalItems = [{
        category_game_type_id : LOTTO,
        id:'lotto',
        is_external: false,
      }]

      let externalItems = this.currentTab === ALL ? this.externalGame : this.externalGame.filter(x => x.category_game_type_id === this.currentTab)
      
      externalItems = this.currentSubtab === ALL ? externalItems : externalItems.filter(x => x.id === this.currentSubtab)

      // HARD CODE FOR INTERNAL GAME LOTTO GROUP
      let extractedGames = [];

      externalItems.forEach(function (item) {
        var games = item.games.map(function (game) {
          game.is_external = true;

          return game;
        })

         extractedGames = extractedGames.concat(games);
      });

      extractedGames.sort((a, b) => {
        if (a.order_priority !== null && b.order_priority !== null) {
          if (a.order_priority !== b.order_priority) {
              return a.order_priority - b.order_priority;
          }
        } else if (a.order_priority !== null && b.order_priority === null) {
            return -1;
        } else if (a.order_priority === null && b.order_priority !== null) {
            return 1;
        }

        if (a.game_type_id !== null && b.game_type_id !== null) {
          if (a.game_type_id !== b.game_type_id) {
              return a.game_type_id - b.game_type_id;
          }
        } else if (a.game_type_id !== null && b.game_type_id === null) {
            return -1;
        } else if (a.game_type_id === null && b.game_type_id !== null) {
            return 1;
        }

        return a.id - b.id;
      });

      switch(this.currentTab) {
        case ALL:
          return [...internalItems, ...extractedGames]
        case LOTTO:
          return [...internalItems, ...extractedGames]
        default:
          return [...extractedGames]
      } 
    },

    subTabs () {
      const externalItems = this.currentTab === ALL ? this.externalGame : this.externalGame.filter(x => x.category_game_type_id === this.currentTab)

      var gametypes = externalItems.map(function (item) {
        return { id: item.id, name: item.name } ;
      })

      switch(this.currentTab) {
        case ALL:
        case LOTTO:
          return []
        default:
          return [{id: ALL, name: 'all'}, ...gametypes]
      } 
    }
  },
  watch: {
    externalGame () {
      this.mapTabsCategoryGameType()
    },
    currentTab () {
      this.currentSubtab = ALL
    }
  },
  async mounted () {
    this.mapTabsCategoryGameType()
  },
  methods : { 
    externalGamePath,
    mapTabsCategoryGameType () { 
      const externalGameItems = 
        EXTERNALTAB.filter(e=>this.externalGame.find(x=>x.category_game_type_id === e.tab))
      this.tabs = [].concat(INTERNALTAB,externalGameItems)
    },
    async topUp (id) {
      if(isGameTypeIdSeamless(id)) {
        return
      }
      const [err] = await apiExternal.postTransfer(id)
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      } 
    }, 

    isIOS () {
      return /MacIntel/.test(navigator.platform)  && navigator.maxTouchPoints && navigator.maxTouchPoints > 2
    },

    async endpoint (id) {
      let isIpad = this.isIOS()
      return isIpad ? apiExternal.getLoginGameMobile(id) : apiExternal.getLoginGame(id) 
    },

    async gotoExternalGame (id,name,category_game_type_id) {  
      //only lotto game to route page
      if(category_game_type_id === LOTTO) {
        this.$router.push({
          name: ROUTE_INTERNAL_LOTTO
        })
        return
      }
      
      if(category_game_type_id === POWER_BALL) {
        this.$router.push({
          name: ROUTE_POWER_BALL
        })
        return
      }

      let windowReference = IsInternalApp() ? window : window.open() ;  
      const [err,data,message] = await this.endpoint(id)
      
      if(err) {
        windowReference.close()
        this.$alert('',err,'warning') 
        return
      }

      if (data && data.html_to) {
        this.$store.dispatch('userProfile/ACTION_WALLET')
        windowReference?.document.write(data.html_to);
      } else if(data && data.redirect_to) {
        windowReference.close()
        this.$alert('',message,'warning')
      }  

      this.$ga.event('Button', 'GotoExternalgame', 'CasinoPage-V2',name )  
    },  
  }
}
</script>
<style scoped>
.sub-category {
  font-size: 14px;
  height: 26px !important;
}
.container-card {
  background: #E89E38;
  border-radius: 10px;
  padding: 4px;
}
</style>